export const ACCOUNT = "/account";
export const ACCOUNT_AVATAR = "/account/avatar";
export const ACCOUNT_INFO = "/account/info";
export const ACCOUNT_APPLICATION_RESET_PASSWORD =
  "/account/application/reset-password";
export const ACCOUNT_RESET_PASSWORD = "/account/reset-password";
export const ACCOUNT_RESET_PASSWORD_TOKEN = "/account/reset-password/{ssoId}";

export const AUTH_LOGIN = "/auth/login";
export const AUTH_LOGOUT = "/auth/logout";
export const AUTH_PHONE_VALIDATION = "/user/phone/validation/{code}";
export const AUTH_PHONE_VALIDATION_SEND_CODE = "/user/phone/validation";

export const BANK_ACCOUNTS = "/bank-accounts";
export const BANK_ACCOUNTS_ID = "/bank-accounts/{id}";
export const BUSINESS_RECEIPT = "/business/receipt";

export const CARD_BALANCE = "/card/balance";
export const CARD_CANCEL = "/card/cancel";
export const CARD_RESTORE_NIP = "/card/restore-nip";
export const CARD_TRANSACTIONS = "/card/transactions";

export const CATALOG_BUSINESS = "/catalog/business";

export const CLIENT_APPLICATION = "/client/application";
export const CLIENT_APPLICATION_ID = "/client/application/{id}";

export const DASHBOARD = "/dashboard";

export const DISTRIBUTORS_CALCULATION = "/calculations/{code}";
export const DISTRIBUTORS_CODES = "/codes";

export const FUNDS = "/funds";

export const INVOICE = "/invoice";
export const INVOICE_AUTOMATIC = "/invoice/automatic";
export const INVOICE_AUTOMATIC_USER = "/invoice/automatic/user";
export const INVOICE_FISCAL_REGIME_CATALOG = "/invoice/catalog/fiscal-regime";

export const NOTIFICATIONS = "/notifications";

export const OPERATIONS = "/operations";
export const OPERATIONS_APPLY_REVERSAL_ID = "/operations/apply-reversal/{id}";
export const OPERATIONS_EXPORT = "/operations/export";
export const OPERATIONS_SEND = "/operations/send";

export const OPERATOR = "/operator";
export const OPERATOR_EMAIL = "/operator/{email}";
export const OPERATOR_USERNAME = "/operator/{username}";

export const PAYMENT = "/payment";
export const PAYMENT_CONVENIENCE_STORE = "/payment/convenience-store";
export const PAYMENT_SEND = "/payment/send";

export const REGISTER = "/register";

export const TRANSFER = "/transfer";

export const USER_EMAIL_STATUS = "/user/email/status";

export const U2U_TRANSFER_BTW_USERS = "/u2u/transferBtwUser";

export const ZIPCODE_CODE = "/zipcode/{code}";
